import { packingIndentEnum, stockTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class IndentFormDto {
    @ApiProperty()
    indentFormId: number;
    @ApiProperty()
    stockType :stockTypeEnum;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    quantity: number;
    @ApiProperty()
    barcode:string;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    indentNumber:string;
    @ApiProperty()
    status:packingIndentEnum;
    @ApiProperty()
    receivedQuantity:number;
    @ApiProperty()
    issuedQuantity:number;
}